const roundsData = [
	{
		roundNumber: 1,
		title: {
			da: 'Runde 1',
			kl: 'Periarneq 1',
		},
		unlocksActions: []
	},
	{
		roundNumber: 2,
		title: {
			da: 'Runde 2',
			kl: 'Periarneq 2',
		},
		unlocksActions: []
	},
	{
		roundNumber: 3,
		title: {
			da: 'Runde 3',
			kl: 'Periarneq 3',
		},
		unlocksActions: []
	},
	{
		roundNumber: 4,
		title: {
			da: 'Runde 4',
			kl: 'Periarneq 4',
		},
		unlocksActions: [
			{actionId: 'innovation', actionOptionId: 'innovation-d'},
			{actionId: 'new-designs', actionOptionId: 'streetart_01'},
			{actionId: 'new-designs', actionOptionId: 'streetart_02'},
			{actionId: 'new-designs', actionOptionId: 'streetart_03'}
		]
	},
	{
		roundNumber: 5,
		title: {
			da: 'Runde 5',
			kl: 'Periarneq 5',
		},
		unlocksActions: [
			{actionId: 'new-designs', actionOptionId: 'horrorart_01'},
			{actionId: 'new-designs', actionOptionId: 'horrorart_02'},
			{actionId: 'new-designs', actionOptionId: 'horrorart_03'}
		]
	},
	{
		roundNumber: 6,
		title: {
			da: 'Runde 6',
			kl: 'Periarneq 6',
		},
		unlocksActions: [
			{actionId: 'new-designs', actionOptionId: 'stjernekunst_01'},
			{actionId: 'new-designs', actionOptionId: 'gueststar_01'},
		]
	},
	{
		roundNumber: 7,
		title: {
			da: 'Runde 7',
			kl: 'Periarneq 7',
		},
		unlocksActions: []
	},
	{
		roundNumber: 8,
		title: {
			da: 'Runde 8',
			kl: 'Periarneq 8',
		},
		unlocksActions: []
	}
];

module.exports = {
	roundsData
};